import { useApplicationContext } from '../context/ApplicationContext';

export const useHideWhitePinsFeatureToggle = (): boolean => {
  const { config } = useApplicationContext();

  return Boolean(config.get<boolean>('BX.HybridSearch.HideWhitePins.Enabled'));
};
